// @flow
export const getScrolledPastSections = <T: {id: string}>(
  sections: Array<T>,
  containerHeight: number,
): Array<T> => {
  return sections.filter((section: T, index: number) => {
    const headingEl = document.getElementById(section.id);
    if (!headingEl) {
      // If no heading element exists with the id of the section, ignore it.
      return false;
    }
    if (index === 0) {
      // The first heading element is always considered "scrolled past" to ensure that
      // at least one section is active.
      return true;
    }
    // Determine whether the section's heading element has scrolled beyond the
    // top 25% of the container.
    const bounds = headingEl.getBoundingClientRect();
    return bounds.height > 0 && bounds.top <= containerHeight / 4;
  });
};
